import isEmpty from 'ramda/src/isEmpty'
import equals from 'ramda/src/equals'
import prop from 'ramda/src/prop'

import validateSchema from 'root/src/shared/util/validateSchema'

import getFormSchema from 'root/src/client/logic/form/selectors/formSchema'
import getFormData from 'root/src/client/logic/form/selectors/formData'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

import ajvErrors from 'root/src/shared/util/ajvErrors'

export default (moduleKey, state, submitKey, isPostFormSubmit, stepId) => new Promise(
	(resolve, reject) => {
		if (isPostFormSubmit) {
			return resolve()
		}
		const moduleId = moduleIdFromKey(moduleKey)
		const formSchema = getFormSchema(state, { moduleId, submitKey, moduleKey, stepId })
		const acceptEmptyString = prop('acceptEmptyString', formSchema)
		const formData = getFormData(state, { moduleKey, stepId, moduleId })
		if (!acceptEmptyString) {
			Object.keys(formData).forEach((key) => {
				if (isEmpty(formData[key]) && !equals(formData[key], 0)) {
					delete formData[key]
				}
			})
		}

		return validateSchema(moduleId, formSchema, formData, submitKey).then(
			({ valid, errors }) => {
				if (valid) {
					resolve(formData)
				} else {
					reject(ajvErrors(formSchema, errors))
				}
			},
		)
	},
)
